<report-filters class="l-block t-row--med"></report-filters>

<invoices *ngIf="displayInvoices" (onDocPdfOpen)="onDocPdfOpen($event)"></invoices>

<receipts *ngIf="displayReceipts" (onDocPdfOpen)="onDocPdfOpen($event)"></receipts>

<balance *ngIf="displayBalance" (onDocPdfOpen)="onDocPdfOpen($event)"></balance>

<modal-popup
  *ngIf="docPdfUrl"
  [flexible]="true"
  [hideHeader]="true"
  [isOpen]="displayDocPdf"
  [focusOnOpen]="false"
>
  <pdf-preview
    [pdfUrl]="docPdfUrl"
    [docNum]="docNum"
    [docTitle]="docTitle"
    (onClose)="displayDocPdf = false; docPdfUrl = null; docTitle = null"
  ></pdf-preview>
</modal-popup>
